module.exports = __webpack_public_path__ + "static/media/purple-blur-bg.07bf9239.jpg";